import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=bc1d7a5e&scoped=true"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1d7a5e",
  null
  
)

export default component.exports